import RecyclingIcon from '@mui/icons-material/Recycling';
import { MarketListingLeadList } from './MarketListingLeadList';

export default {
  list: MarketListingLeadList,
  icon: RecyclingIcon,
  options: { label: 'Market listing leads' },
};
